<template>
   <div class="st-toast st-toast-confirm_overlay container" :class="selfEnterClass" v-show="selfToastShow">
        <div class="page st-toast_mask" @click="closeToast"></div>
        <div class="st-toast-confirm_container">
            <!-- 头像 -->
            <div class="st-toast-confirm_head-img-container container" v-if="headImg">
                <image class="st-toast-confirm_head-img"
                    :src="headImg" mode="widthFix"></image>
            </div>
            <div class="st-toast-confirm_head-img-placeholder" v-if="headImg"></div>
            <!-- 标题 -->
            <div class="st-toast-confirm_title_con" v-show="t_title">
                <span class="st-toast-confirm_title">
                    <span>{{t_title}}</span>
                    <span class="st-toast-confirm_title_line"></span>
                </span>
            </div>
            <!-- 内容 -->
            <div v-for="(text, idx) in contents" :key="'st-toast-content-text_'+idx" class="st-toast-confirm_content_con">
                <div class="st-toast-confirm_content_tx" :class="{
                    'st-toast-content_indent': contents.length == 1
                }" :style="{
                    'marginBottom': $util.pxTransform(t_contentLineHeight + 'px')
                }">
                    {{text}}
                </div>
            </div>

            <!-- 处理子elems嵌套 -->
            <slot>
                <elem v-for="(elem, index) in elems" 
                    :key="'toast_sub_elems_' + index"
                    :mode="elem"
                    :currentPhoto="currentPhoto"
                    :currentTime="currentTime"
                    :canIShow="selfToastShow"
                    :currentImage="currentImage"
                    :scene="scene"
                    :line="line"></elem>
            </slot>
                
            <!-- 按钮组 -->
            <div class="st-toast-confirm_btns flex_r" v-show="t_showBottom">
                <!-- 取消 -->
                <div class="st-toast-confirm_btn st-toast-confirm_cancel" :class="{'st-toast-confirm_btn-long': isCancelTextLong}" v-show="t_showCancel" @click="onCancel">
                    {{t_cancelText}}
                </div>
                <!-- 确定 -->
                <div class="st-toast-confirm_btn st-toast-confirm_confirm" :class="{'st-toast-confirm_btn-long': isConfirmTextLong}" v-show="t_showConfirm" @click="onConfirm">
                    {{t_confirmText}}
                </div>
            </div>

            <!-- 关闭按钮 -->
            <img class="st-toast-close-btn pointer" :style="closeBtnStyle" v-show="t_showCloseIcon" src="./images/close1.png"/>
        </div>
    </div>
</template>

<script>
    import StToast from './StToast'
    export default {
        name: 'StToastConfirm',
        extends: StToast,
        props: {
            title: {
                type: String
            },
            content: {
                default: ''
            },
            contentLineHeight: {
                default: 20
            },
            confirmText: {
                type: String,
                default: '确定'
            },
            cancelText: {
                type: String,
                default: '取消'
            },
            showConfirm: {
                type: Boolean,
                default: true
            },
            showCancel: {
                type: Boolean,
                default: true
            },
            showBottom: {
                type: Boolean,
                default: true
            },
            showCloseIcon: {
                type: Boolean,
                default: false
            },
            closeBtnPosition: {
                type: String,
                default: "topRight",
            },
            headImg: {
                type: String
            }
        },
        computed: {
            contents () {
                let contents = [];
                if (this.$util.typeOf(this.t_content) == 'string') {
                    contents = [this.t_content];
                } else if (this.$util.typeOf(this.t_content) == 'array') {
                    for (let i=0; i<this.t_content.length; i++) {
                        // contents.push( (i+1).toString() + '.' + this.t_content[i] );
                        contents.push( this.t_content[i] );
                    }
                }
                return contents;
            },
            closeBtnStyle () {
                let s = {}
                if (this.closeBtnPosition == "topLeft") {
                    s = {
                        "top": "-40px",
                        "left": "0"
                    }
                } else if (this.closeBtnPosition == "topRight") {
                    s = {
                        "top": "-40px",
                        "right": "0"
                    }
                } else if (this.closeBtnPosition == "bottom") {
                    s = {
                        "bottom": "-40px",
                        "right": "0",
                        "left": "0",
                        "margin": "0 auto"
                    }
                } else if (this.closeBtnPosition == "top") {
                    s = {
                        "top": "-40px",
                        "right": "0",
                        "left": "0",
                        "margin": "0 auto"
                    }
                }
                return s;
            },
            t_title () {
                return this.config['title'] || this.title;
            },
            t_content () {
                return this.config['content'] || this.content;
            },
            t_contentLineHeight () {
                return this.config['contentLineHeight'] || this.contentLineHeight;
            },
            t_confirmText () {
                return this.config['confirmText'] || this.confirmText;
            },
            t_cancelText () {
                return this.config['cancelText'] || this.cancelText;
            },
            isConfirmTextLong () {
                return String(this.t_confirmText || '').length > 4;
            },
            isCancelTextLong () {
                return String(this.t_cancelText || '').length > 4;
            },
            t_showConfirm () {
                if (this.config['showConfirm'] == 'true') {
                    return true;
                } else if (this.config['showConfirm'] == 'false') {
                    return false;
                } else {
                    return this.showConfirm;
                }
            },
            t_showCancel () {
                if (this.config['showCancel'] == 'true') {
                    return true;
                } else if (this.config['showCancel'] == 'false') {
                    return false;
                } else {
                    return this.showCancel;
                }
            },
            t_showCloseIcon () {
                if (this.config['showCloseIcon'] == 'true') {
                    return true;
                } else if (this.config['showCloseIcon'] == 'false') {
                    return false;
                } else {
                    return this.showCloseIcon;
                }
            },
            t_showBottom () {
                if (this.config['showBottom'] == 'false' || this.showBottom === false) {
                    return false;
                } else {
                    return true;
                }
            }
        },
        data () {
            return {}
        },
        methods: {
            onConfirm () {
                this.$emit("onConfirm");
                this.$emit("changeShowStatus", false)
            },
            onCancel () {
                this.$emit("onCancel");
                this.$emit("changeShowStatus", false)
            }
        }
    }
</script>

<style>
    .st-toast-confirm_overlay {
        position: fixed;
        z-index: 9999;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .st-toast-confirm_container {
        position: relative;
        z-index: 1;
        border-radius: 12px;
        padding-bottom: 30px;
        background-color: white;
        width: 450px;
        max-width: calc(100vw - 48px);
        box-sizing: border-box;
        /* height: 346px; */
        /* top: 50%; */
        /* margin-top: -173px; */
    }
    .st-toast-confirm_head-img-container {
        position: absolute;
        left: 0;
        right: 0;
        top: -68px;
        margin: 0 auto;
        width: 128px;
        height: 128px;
        background: linear-gradient(270deg, #FF9000 0%, #FF5000 100%);
        border-radius: 50%;
    }
    .st-toast-confirm_head-img {
        width: 116px;
        height: 116px;
        border-radius: 50%;
    }
    .st-toast-confirm_head-img-placeholder {
        width: 100%;
        height: 50px;
    }
    .st-toast-confirm_title_con {
        text-align: center;
        margin: 24px 0;
    }
    .st-toast-confirm_title {
        display: inline-block;
        position: relative;
        font-weight: bold;
        /* font-weight: 500; */
        color: #333333;
        font-size: 30px;
    }
    .st-toast-confirm_title_line {
        position: absolute;
        background-color: #ff91004b;
        -webkit-filter: blur(0.064rem);
        filter: blur(0.064rem);
        bottom: -3px;
        height: 0.384rem;
        border-radius: 36%;
        /* width: 350px;
        margin-left: -175px;
        left: 50%; */
        width: 100%;
        margin: 0 auto;
        left: 0;
        right: 0;
    }
    .st-toast-confirm_content_tx {
        padding: 0 20px;
        font-size: 24px;
        color: #666666;
    }
    .st-toast-confirm_btns {
        padding-top: 30px;
    }
    .st-toast-confirm_btn {
        position: relative;
        height: 60px;
        border-radius: 29px;
        font-size: 29px;
        box-sizing: border-box;
        text-align: center;
        line-height: 60px;
        padding: 0 40px;
    }
    .st-toast-confirm_btn-long {
        /* font-size: 0.6rem; */
        font-size: 22px;
    }
    .st-toast-confirm_cancel {
        color: #FF9000;
        border: solid 2px #FF5000;
        line-height: 59px;
    }
    .st-toast-confirm_confirm {
        color: white;
        background: linear-gradient(270deg, #FF9000 0%, #FF5000 100%);
    }
    .st-toast-content_indent {
        text-indent: 18px;
    }
    .st-toast-close-btn {
        position: absolute;
        width: 40px;
        height: 40px;
    }
</style>
